export default class extends (window.google ? google.maps.OverlayView : {})
{
	constructor(opt_options)
	{
		super()

		// Initialization
		this.setValues(opt_options)

		// Label specific
		var span = this.span_ = document.createElement('span')
		span.style.cssText = 'position:relative;left:-50%;white-space:nowrap'

		var div = this.div_ = document.createElement('div')
		div.appendChild(span)
		div.style.cssText = 'position:absolute;display:none'
	}

	onAdd()
	{
		var pane = this.getPanes().overlayLayer
		pane.appendChild(this.div_)

		// Ensures the label is redrawn if the text or position is changed.
		var me = this
		this.listeners_ = [
			google.maps.event.addListener(this, 'position_changed', e => me.draw()),
			google.maps.event.addListener(this, 'text_changed', e => me.draw())
		]
	}

	onRemove()
	{
		this.div_.parentNode.removeChild(this.div_)

		// Label is removed from the map, stop updating its position/text.
		for(var i = 0, I = this.listeners_.length; i < I; ++i)
		{
			google.maps.event.removeListener(this.listeners_[i])
		}
	}

	draw()
	{
		var projection = this.getProjection()
		var position = projection.fromLatLngToDivPixel(this.get('position'))

		var div = this.div_
		div.style.left = position.x + 'px'
		div.style.top = position.y + 'px'
		div.style.display = 'block'

		this.span_.innerHTML = this.get('text').toString()
	}
}



// WEBPACK FOOTER //
// ./source/scripts/modules/map/label.js